<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-200">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Fale Conosco</h2>
                        <p class="lead text-white">Tem interesse em algum filme? Quer realizar alguma troca? Preencha o formulário abaixo com seus dados que entrarei em contato. Aguardo sua mensagem!</p>
                    </div>
                </div>
                <div class="d-none d-lg-block pb-100">
	                
	            </div>
            </div>
        </section>
        <section class="section section-lg pt-lg-0 section-contact-us">
            <div class="container">
                <div class="row justify-content-center mt--300">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1 text-center">Qual o assunto que você deseja tratar?</h4>
                            <p class="mt-0 text-center">Preencha as informações abaixo de forma clara e objetiva.</p>
                            <base-input class="mt-5"
                                        alternative
                                        placeholder="Seu nome"
                                        v-model="contactForm.nome"
                                        :valid="formerrors.nome"
                                        addon-left-icon="fa fa-user">
                            </base-input>
                            <base-input alternative
                                        placeholder="Seu e-mail"
                                        v-model="contactForm.email"
                                        :valid="formerrors.email"
                                        addon-left-icon="ni ni-email-83">
                            </base-input>
                            <base-input
                                        alternative
                                        placeholder="Assunto"
                                        v-model="contactForm.assunto"
                                        :valid="formerrors.assunto"
                                        addon-left-icon="fa fa-question">
                            </base-input>
                            <base-input class="mb-4">
                                    <textarea class="form-control form-control-alternative" name="name" rows="4"
                                              cols="80" placeholder="Preencha sua mensagem" :valid="formerrors.mensagem" v-model="contactForm.mensagem"></textarea>
                            </base-input>
                            <div class="mb-4">
                                <vue-recaptcha ref="recaptcha" :sitekey="recaptchaKey" :loadRecaptchaScript="true" @verify="onVerify" @expired="onExpired" class="recaptcha-block"></vue-recaptcha>
                            </div>
                            <base-button type="default" round block size="lg" :disabled="$wait.is('contact.form.submit')" @click="dispatchContact()">
                                Enviar mensagem
                            </base-button>
                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>

import recaptcha from '@/settings/recaptcha.json';
import VueRecaptcha from 'vue-recaptcha';

export default {
    name: 'contato',
    components: {
        VueRecaptcha
    },
    data() {
        return {
            contactForm: {
                assunto: ( !this.$route.query.assunto ) ? '' : this.$route.query.assunto,
                mensagem: ( !this.$route.query.mensagem ) ? '' : this.$route.query.mensagem
            },
            formerrors: {},
            modal: {},
        }
    },
    methods: {
        onVerify(token){
            this.contactForm.recaptcha = token;
        },
        onExpired(){
            this.contactForm.recaptcha = null;
        },
        resetModal() {
            this.modal = {
                title: 'Falha na Operação!',
                body: 'Não foi possível completar a operação',
                classe: 'modal-danger',
                icon: 'fa fa-times-circle',
                okButton: 'OK',
            };
        },
        dispatchContact() {
            if ( !this.contactForm.recaptcha ) {
                this.modal.body = 'Por favor, confirme que você não é um robô antes de enviar o formulário!';
                this.$store.dispatch('modal/invokeStateModal', this.modal);
                return false;
            }
            const payload = this.contactForm;
            this.formerrors = {};
            this.$wait.start('contact.form.submit');
            this.axios.post('/v1/contato', payload)
            .then(response => {
              let contactReturn = response.data;
              const firstName = contactReturn.nome.split(' ')[0];
              this.modal.title = 'Mensagem Enviada!';
              this.modal.classe = 'modal-success';
              this.modal.icon = 'fa fa-envelope-o';
              this.modal.body = `${firstName}, sua mensagem foi enviada com sucesso! Em breve entraremos em contato.`;
              this.$store.dispatch('modal/invokeStateModal', this.modal);
              this.$refs.recaptcha.reset();
              this.resetModal();
            })
            .catch(e => {
              let errors = e.data;
              Object.keys(errors).forEach(key => {
                this.formerrors[key] = false;
              });
              this.modal.body = 'Por favor, verifique os campos a seguir antes de continuar!';
              this.$store.dispatch('modal/invokeStateModal', this.modal);
              this.$refs.recaptcha.reset();
            }).then(response =>{
                this.$wait.end('contact.form.submit');
                this.contactForm = {};
            });
        }
    },
    computed: {
        recaptchaKey() {
            return recaptcha.site_key;
        }
    },
    created() {
        this.resetModal();
    }
};
</script>
<style lang="scss" scoped>
.form-group.input-group-alternative.has-danger {
    border: 1px solid #fb6340;
}
</style>
